(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-site-translation-property', {
            parent: 'entity',
            url: '/public-site-translation-property?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteTranslationProperty.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-translation-property/public-site-translation-properties.html',
                    controller: 'PublicSiteTranslationPropertyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteTranslationProperty');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-site-translation-property-detail', {
            parent: 'entity',
            url: '/public-site-translation-property/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteTranslationProperty.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-translation-property/public-site-translation-property-detail.html',
                    controller: 'PublicSiteTranslationPropertyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteTranslationProperty');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicSiteTranslationProperty', function($stateParams, PublicSiteTranslationProperty) {
                    return PublicSiteTranslationProperty.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-site-translation-property',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-site-translation-property-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation-property/public-site-translation-property-dialog.html',
                    controller: 'PublicSiteTranslationPropertyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteTranslationProperty', function(PublicSiteTranslationProperty) {
                            return PublicSiteTranslationProperty.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-translation-property.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation-property/public-site-translation-property-dialog.html',
                    controller: 'PublicSiteTranslationPropertyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                hotelId: null,
                                message: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-site-translation-property', null, { reload: 'public-site-translation-property' });
                }, function() {
                    $state.go('public-site-translation-property');
                });
            }]
        })
        .state('public-site-translation-property.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation-property/public-site-translation-property-dialog.html',
                    controller: 'PublicSiteTranslationPropertyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteTranslationProperty', function(PublicSiteTranslationProperty) {
                            return PublicSiteTranslationProperty.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-translation-property', null, { reload: 'public-site-translation-property' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-translation-property.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation-property/public-site-translation-property-delete-dialog.html',
                    controller: 'PublicSiteTranslationPropertyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicSiteTranslationProperty', function(PublicSiteTranslationProperty) {
                            return PublicSiteTranslationProperty.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-translation-property', null, { reload: 'public-site-translation-property' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
